<svg version="1.1"
     xmlns="http://www.w3.org/2000/svg"
     [attr.width]="width" [attr.height]="height"
     viewBox="-146.66666666666663 1275 1445.3333333333333 813"
     id="governance-status">
  <defs>
    <style
      type="text/css">@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700|Inconsolata:400');</style>
  </defs>
  <g id="background">
    <polygon opacity="0.2" points="960 1443, 1216 1591, 480 2017, 224 1869" fill="#e6e7e8" stroke-width="0"
             stroke="#ffffff"></polygon>
    <polygon opacity="0.1" points="832 1369, 944 1434, 208 1859, 96 1795" fill="#e6e7e8" stroke-width="0"
             stroke="#ffffff"></polygon>
    <polygon opacity="0.1" points="704 1295, 816 1360, 80 1785, -32 1721" fill="#e6e7e8" stroke-width="0"
             stroke="#ffffff"></polygon>
  </g>
  <g id="lines">
    <g id="line_api_to_ingest"
       [attr.opacity]="lines.apiToIngest.colours.opacity">
      <line x1="272" y1="1952" x2="397" y2="1880"
            [attr.stroke]="lines.apiToIngest.colours.line" stroke-width="10" stroke-linecap="round">
      </line>
      <polygon points="416 1869, 365 1879, 391 1883, 397 1898, 416 1869"
               stroke-linejoin="round" [attr.fill]="lines.apiToIngest.colours.line"
               [attr.stroke]="lines.apiToIngest.colours.line" stroke-width="1"></polygon>
    </g>
    <g
      id="line_ingest_to_validate" [attr.opacity]="lines.ingestToValidate.colours.opacity">
      <line x1="400" y1="1822" x2="288"
            y2="1758" [attr.stroke]="lines.ingestToValidate.colours.line" stroke-width="7"
            stroke-linecap="round"></line>
    </g>
    <g
      id="line_validate_payload" [attr.opacity]="lines.ingestToValidate.colours.opacity">
      <line x1="288" y1="1758" x2="336"
            y2="1730" [attr.stroke]="lines.ingestToValidate.colours.line" stroke-width="7"
            stroke-linecap="round"></line>
      <polygon
        points="352 1721, 311 1729, 332 1732, 337 1744, 352 1721"
        stroke-linejoin="round" [attr.fill]="lines.ingestToValidate.colours.line"
        [attr.stroke]="lines.ingestToValidate.colours.line" stroke-width="1"></polygon>
    </g>
    <g
      id="line_enrich_to_analyse" [attr.opacity]="lines.enrichToAnalyse.colours.opacity">
      <line x1="784" y1="1600" x2="544"
            y2="1462" [attr.stroke]="lines.enrichToAnalyse.colours.line" stroke-width="7" stroke-linecap="round"></line>
    </g>
    <g
      id="line_enrich_to_validate" [attr.opacity]="lines.enrichToValidate.colours.opacity">
      <line x1="784" y1="1600" x2="672"
            y2="1536" [attr.stroke]="lines.enrichToValidate.colours.line" stroke-width="7"
            stroke-linecap="round"></line>
    </g>
    <g
      id="line_analyse_enriched" [attr.opacity]="lines.enrichToAnalyse.colours.opacity">
      <line x1="544" y1="1462" x2="592"
            y2="1434" [attr.stroke]="lines.enrichToAnalyse.colours.line" stroke-width="7" stroke-linecap="round"></line>
      <polygon
        points="608 1425, 567 1433, 588 1436, 593 1448, 608 1425"
        stroke-linejoin="round" [attr.fill]="lines.enrichToAnalyse.colours.line"
        [attr.stroke]="lines.enrichToAnalyse.colours.line" stroke-width="1"></polygon>
    </g>
    <g
      id="line_validate_enriched" [attr.opacity]="lines.enrichToValidate.colours.opacity">
      <line x1="672" y1="1536" x2="720"
            y2="1508" [attr.stroke]="lines.enrichToValidate.colours.line" stroke-width="7"
            stroke-linecap="round"></line>
      <polygon
        points="736 1499, 695 1507, 716 1510, 721 1522, 736 1499"
        stroke-linejoin="round" [attr.fill]="lines.enrichToValidate.colours.line"
        [attr.stroke]="lines.enrichToValidate.colours.line" stroke-width="1"></polygon>
    </g>

    <g
      id="line_ingest_to_transform" [attr.opacity]="lines.ingestToTransform.colours.opacity">

      <line x1="496" y1="1822" x2="781" y2="1658" [attr.stroke]="lines.ingestToTransform.colours.line" stroke-width="10" stroke-linecap="round"></line>
      <polygon points="800 1647, 749 1657, 775 1661, 781 1676, 800 1647" stroke-linejoin="round"
               [attr.fill]="lines.ingestToTransform.colours.line"
               [attr.stroke]="lines.ingestToTransform.colours.line" stroke-width="1"></polygon>
    </g>

    <g
      id="line_api_to_sparrow" [attr.opacity]="lines.apiToSparrow.colours.opacity">
      <line x1="207" y1="1989" x2="163"
            y2="2015" [attr.stroke]="lines.apiToSparrow.colours.line" stroke-width="10" stroke-linecap="round"></line>
      <polygon
        points="144 2026, 195 2015, 169 2011, 163 1996, 144 2026"
        stroke-linejoin="round" [attr.fill]="lines.apiToSparrow.colours.line"
        [attr.stroke]="lines.apiToSparrow.colours.line" stroke-width="1"></polygon>
    </g>
  </g>
  <g
    id="lambdas">
    <g id="ingest"
       [attr.opacity]="lambdas.ingest.colours.opacity">
      <svg x="400" y="1764" height="113.438" width="96" viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.ingest.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.ingest.colours.front" fill-rule="evenodd">
          </path>
          <path d="M-412.333 107.134v4.785l8.29 4.786v-4.786z"
                [attr.fill]="lambdas.ingest.colours.front" fill-rule="evenodd">
          </path>
          <path d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
                fill="none" [attr.stroke]="lambdas.ingest.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.ingest.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.ingest.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.ingest.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.ingest.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.ingest.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.ingest.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.ingest.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.ingest.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="transform" [attr.opacity]="lambdas.transform.colours.opacity">
      <svg x="784" y="1542"
           height="113.438"
           width="96"
           viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.transform.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.transform.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.transform.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.transform.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.transform.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.transform.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.transform.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.transform.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.transform.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.transform.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.transform.colours.text" font-family="Droid Serif" font-size="9.971"
              style="line-height: 1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="validatePayload" [attr.opacity]="lambdas.validatePayload.colours.opacity">
      <svg
        x="336" y="1616" height="113.438" width="96" viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.validatePayload.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.validatePayload.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.validatePayload.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.validatePayload.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.validatePayload.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.validatePayload.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.validatePayload.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validatePayload.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.validatePayload.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.validatePayload.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.validatePayload.colours.text" font-family="Droid Serif" font-size="9.971" style="line-height:
1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="validateEnriched" [attr.opacity]="lambdas.validateEnriched.colours.opacity">
      <svg
        x="720" y="1394" height="113.438" width="96" viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.validateEnriched.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.validateEnriched.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.validateEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.validateEnriched.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.validateEnriched.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.validateEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validateEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.validateEnriched.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.validateEnriched.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.validateEnriched.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.validateEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.validateEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.validateEnriched.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.validateEnriched.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.validateEnriched.colours.text" font-family="Droid Serif" font-size="9.971" style="line-height:
1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
    <g id="analyseEnriched" [attr.opacity]="lambdas.analyseEnriched.colours.opacity">
      <svg
        x="592" y="1320" height="113.438" width="96" viewBox="0 0 25.4 30.014">
        <g transform="translate(412.599 -86.957)">
          <path d="M-395.754 111.92l8.29-4.786v4.785l-8.29 4.786z"
                [attr.fill]="lambdas.analyseEnriched.colours.side" fill-rule="evenodd">
          </path>
          <path d="M-404.044 111.92h8.29v4.785h-8.29z"
                [attr.fill]="lambdas.analyseEnriched.colours.front" fill-rule="evenodd">
          </path>
          <path
            d="M-412.333 107.134v4.785l8.29 4.786v-4.786z" [attr.fill]="lambdas.analyseEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 107.134l8.29 4.785h8.289l8.29-4.785M-404.044 111.92v4.785M-395.754 111.92v4.785"
            fill="none" [attr.stroke]="lambdas.analyseEnriched.colours.highlight" stroke-width=".26588"></path>
          <path
            d="M-412.333 102.348v9.571l8.29 4.786h8.289l8.29-4.786v-9.571l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".53176"></path>
          <path
            d="M-395.754 106.75l8.29-4.786v4.786l-8.29 4.786z" [attr.fill]="lambdas.analyseEnriched.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 106.75h8.29v4.786h-8.29z" [attr.fill]="lambdas.analyseEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.analyseEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 101.964l8.29 4.786h8.289l8.29-4.786M-404.044 106.75v4.786M-395.754 106.75v4.786"
            fill="none" [attr.stroke]="lambdas.analyseEnriched.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 97.178v9.572l8.29 4.786h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none"
            stroke="#000000"
            stroke-width=".532"></path>
          <path
            d="M-412.333 92.01v4.785l8.29 4.786h8.289l8.29-4.786v-4.786l-8.29-4.786h-8.29z"
            [attr.fill]="lambdas.analyseEnriched.colours.main" fill-rule="evenodd"></path>
          <path
            d="M-395.754 101.58l8.29-4.785v4.786l-8.29 4.786z" [attr.fill]="lambdas.analyseEnriched.colours.side"
            fill-rule="evenodd"></path>
          <path
            d="M-404.044 101.58h8.29v4.787h-8.29z" [attr.fill]="lambdas.analyseEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795v4.786l8.29 4.786v-4.786z" [attr.fill]="lambdas.analyseEnriched.colours.front"
            fill-rule="evenodd"></path>
          <path
            d="M-412.333 96.795l8.29 4.786h8.289l8.29-4.786M-404.044 101.58v4.787M-395.754 101.58v4.787"
            fill="none" [attr.stroke]="lambdas.analyseEnriched.colours.highlight" stroke-width=".266"></path>
          <path
            d="M-412.333 92.01v9.57l8.29 4.787h8.289l8.29-4.786v-9.572l-8.29-4.786h-8.29z" fill="none" stroke="#000000"
            stroke-width=".532"></path>
          <circle cx="-136.478"
                  cy="325.284" [attr.fill]="lambdas.analyseEnriched.colours.background" r="5.801"
                  transform="scale(1.22475 .7071) rotate(45)"></circle>
          <g
            font-family="sans-serif" font-size="3.191" stroke-width=".266" style="line-height: 0%;">
            <path
              d="M-399.242 93.57l.48-.601q.222-.275.177-.448-.04-.17-.467-.416l-.507-.293 1.065-.614.937.541q.825.476.92.934.1.46-.417 1.114l-3.452 4.39-1.622-.937 1.654-2.121-3.729.923-1.622-.936z"
              [attr.fill]="lambdas.analyseEnriched.colours.text" font-family="Droid Serif" font-size="9.971" style="line-height:
1.25;">
            </path>
          </g>
        </g>
      </svg>
    </g>
  </g>
  <g id="apigateway" [attr.opacity]="apigateway.colours.opacity">
    <svg id="api" x="162"
         y="1908"
         height="108.05"
         width="123"
         viewBox="0 0 32.544 28.588">
      <path d="M10.115 6.02v14.218l7.873-4.318V1.474z"
            [attr.fill]="apigateway.colours.highlight" fill-rule="evenodd" [attr.stroke]="apigateway.colours.highlight"
            stroke-width=".268">
      </path>
      <path
        d="M.265 2.228l9.85 3.791v14.219l-9.85-8.531z" [attr.fill]="apigateway.colours.front" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M10.115 6.02l7.873-4.546L3.548.332.265 2.228z" [attr.fill]="apigateway.colours.main" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M.265 11.707l9.85 8.53 7.873-4.317V1.474L3.392.271.265 2.076z" fill="none" fill-rule="evenodd"
        stroke="#000000"
        stroke-width=".529"></path>
      <path
        d="M22.429 3.65L14.22 8.39l14.828 10.397 3.231-1.866z" [attr.fill]="apigateway.colours.main" fill-rule="evenodd"
        stroke="#fff8f7" stroke-width=".268"></path>
      <path
        d="M14.22 8.39V22.61l14.777 5.687.051-9.509z" [attr.fill]="apigateway.colours.front" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M29.048 18.787l3.231-1.866V26.4l-3.282 1.897z" [attr.fill]="apigateway.colours.highlight" fill-rule="evenodd"
        [attr.stroke]="apigateway.colours.highlight" stroke-width=".265"></path>
      <path
        d="M22.429 3.65L14.22 8.39V22.61l14.777 5.687 3.282-1.897v-9.478z" fill="none" fill-rule="evenodd"
        stroke="#000000"
        stroke-width=".529"></path>
    </svg>
  </g>
  <g id="icons">
    <svg id="sparrow" x="80" y="2026"
         [attr.opacity]="icons.sparrow.colours.opacity" overflow="visible">
      <g transform="scale(0.40000000000000013) ">
        <svg x="-200" y="-200" width="400" height="400">
          <svg viewBox="0 0 400 400" height="400" width="400">
            <g
              [attr.fill]="icons.sparrow.colours.main" stroke-width="2">
              <path stroke-width="1.5" stroke="black" fill-rule="evenodd"
                    d="M67.275 68.93c-13.71 4.887-31.279 28.118-23.235 30.721 5.168 1.673 15.541 14.019 17.974 21.392 3.164 9.586.234 12.957-11.259 12.957H42v15.105c0 42.468 22.409 85.922 52.523 101.85 9.159 4.844 9.185 4.051-.523 15.799-5.256 6.361-8 11.665-8 15.464 0 6.372 3.05 7.787 4.919 2.282 3.171-9.34 6.867-11.695 10.412-6.634l3.287 4.692 2.213-6.779c2.344-7.179 7.995-8.708 18.669-5.051 3.489 1.195 4.5.789 4.5-1.807 0-2.235 1.054-2.944 3.17-2.132 1.744.669 8.269 1.712 14.5 2.319 6.232.606 14.248 1.544 17.815 2.085l6.484.982-5.911 11.71c-8.057 15.961-13.28 19.786-25.466 18.655-9.974-.927-20.592 1.863-20.592 5.41 0 1.179 5.264 2.05 12.392 2.05h12.391l-8.891 5.718c-22.025 14.164-23.01 21.956-1.295 10.243l15.137-8.165-1.99 7.206c-4.504 16.311-1.199 19.035 6.064 4.998 3.699-7.15 8.405-15.146 10.459-17.77 2.053-2.623 3.733-7.494 3.733-10.823 0-8.84 12.932-29.756 20.654-33.407 14.037-6.636 9.443-13.778-14.388-22.373-40.607-14.646-60.578-27.664-68.46-44.627-4.991-10.74-4.678-15.987.382-6.399 2.206 4.181 5.316 8.102 6.912 8.714 1.595.612 2.9 2.21 2.9 3.55 0 3.478 7.614 9.988 17.459 14.929C160.553 235.392 274.322 272 289.488 272c7.797 0 4.694-6.306-4.488-9.12-4.4-1.349-17.45-5.342-29-8.874-22.389-6.846-58.51-20.163-57.481-21.191.34-.341 17.109 4.287 37.265 10.283C255.94 249.094 273.893 254 275.68 254c6.33 0-12.147-10.412-28.34-15.97-22.344-7.669-39.562-14.475-38.729-15.308.381-.381 9.747 2.357 20.814 6.084C260.961 239.427 262 239.535 262 232.197c0-5.019-.99-6.362-5.5-7.46-8.397-2.044-36.832-13.072-35.958-13.945.423-.424 8.744 1.924 18.489 5.219 21.894 7.4 25.879 7.645 24.23 1.489-.664-2.475-1.219-5.095-1.234-5.823-.015-.728-6.333-3.797-14.039-6.821-15.652-6.141-17.843-8.608-3.219-3.625 13.918 4.742 13.346 2.617-3.936-14.63-16.544-16.511-15.781-16.25 5.272 1.805 21.75 18.652 27.996 31.522 22.976 47.339-1.076 3.389.758 3.796 22.93 5.093 29.802 1.743 41.407 4.689 67.489 17.135 17.753 8.47 20.5 9.286 20.5 6.082 0-4.273-10.712-13.988-15.653-14.196-2.807-.117-2.741-.378.411-1.616 4.711-1.851-16.799-11.794-37.354-17.268-7.477-1.991-12.71-4.168-11.628-4.837 1.082-.668-5.4-5.014-14.404-9.657-16.852-8.689-59.173-45.023-86.461-74.23C170.257 94.458 97.301 58.225 67.275 68.93m-37.157 46.321c-5.655 6.188-9.814 11.72-9.24 12.293 2.242 2.243 34.166 3.977 36.622 1.989 3.77-3.051 3.003-9.185-1.5-11.997-2.2-1.374-4-3.492-4-4.707 0-2.725-6.538-8.829-9.457-8.829-1.178 0-6.769 5.063-12.425 11.251m55.499-3.923c.813 5.712-6.743 8.403-11.168 3.978-2.601-2.601-2.674-3.624-.452-6.302 3.695-4.452 10.858-3.019 11.62 2.324m115.073 74.343c-1.14 1.831-5.137 4.368-8.882 5.637-4.649 1.576-6.698 3.453-6.461 5.917.838 8.709-3.013 11.28-15.539 10.374-8.359-.605-11.808-.149-11.808 1.559 0 5.347-18.588 6.624-29 1.992-5.606-2.494-5.182-2.601 6.464-1.635 13.619 1.13 19.538-1.467 17.871-7.841-.783-2.995-.303-3.262 2.842-1.579 12.034 6.44 22.438 1.743 21.284-9.611-.643-6.338-.487-6.483 5.728-5.317 8.045 1.51 14.77-1.972 14.946-7.737l.136-4.43 2.246 4.671c1.569 3.263 1.622 5.675.173 8"></path>
            </g>
          </svg>
        </svg>
      </g>
    </svg>
  </g>
  <g id="labels">
    <svg x="736" y="1758" overflow="visible" [attr.opacity]="labels.transform.colours.opacity">
      <text
        font-family="Open Sans" y="59.3" font-size="45pt" [attr.fill]="lambdas.transform.colours.label" font-weight="bold"
        transform="matrix(0.707 -0.409 0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">TRANSFORM</tspan></text>
    </svg>
    <svg x="432" y="1933" overflow="visible" [attr.opacity]="labels.ingest.colours.opacity">
      <text
        font-family="Open Sans" y="59.3" font-size="45pt" [attr.fill]="lambdas.ingest.colours.label" font-weight="bold"
        transform="matrix(0.707 -0.409 0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">INGEST</tspan></text>
    </svg>
    <svg x="448" y="1628" overflow="visible" [attr.opacity]="labels.validate.colours.opacity">
      <text
        font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.validate.colours.label" font-weight="bold"
        transform="matrix(0.707 -0.409 0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">VALIDATE</tspan></text>
    </svg>
    <svg x="112" y="1674" overflow="visible" [attr.opacity]="labels.analyse.colours.opacity">
      <text
        font-family="Open Sans" y="46.76" font-size="34pt" [attr.fill]="labels.analyse.colours.label" font-weight="bold"
        transform="matrix(0.707 -0.409 0.707 0.409 0 0)" xml:space="preserve"><tspan x="8" dy="0">GOVERNANCE CHECKS</tspan></text>
    </svg>
  </g>
</svg>
